const testimonials = [
  {
    id: 1,
    imageUrl: "https://images.pexels.com/photos/6129242/pexels-photo-6129242.jpeg?_gl=1*8yfwm4*_ga*MjcyNDcwNjg5LjE3ODI3MTQ1MDI.*_ga_8JE65Q40S6*czE3ODI3MTQ1MDIkbzEkZzAkdDE3ODI3MTQ1MDIkajYwJGwwJGgw",
    name: "Priya Sharma",
    title: "Excellent Service!",
    subName: "Verified Buyer",
    designation: "Regular Customer",
    rating: 5,
    desc: "Ordering my medicines online was quick and hassle-free. The products arrived on time, were well-packaged, and exactly as described. I'll definitely order again."
  },
  {
    id: 2,
    imageUrl: "https://images.pexels.com/photos/7108346/pexels-photo-7108346.jpeg?_gl=1*bhgws5*_ga*MjcyNDcwNjg5LjE3ODI3MTQ1MDI.*_ga_8JE65Q40S6*czE3ODI3MTQ1MDIkbzEkZzAkdDE3ODI3MTQ1MDIkajYwJGwwJGgw",
    name: "Rahul Verma",
    title: "Fast Delivery",
    subName: "Happy Customer",
    designation: "Working Professional",
    rating: 4.5,
    desc: "I received my prescription medicines within a day. The ordering process was simple, and the customer support team was very helpful throughout."
  },
  {
    id: 3,
    imageUrl: "https://images.pexels.com/photos/6129158/pexels-photo-6129158.jpeg?_gl=1*189o9tk*_ga*MjcyNDcwNjg5LjE3ODI3MTQ1MDI.*_ga_8JE65Q40S6*czE3ODI3MTQ1MDIkbzEkZzAkdDE3ODI3MTQ1MDIkajYwJGwwJGgw",
    name: "Ananya Reddy",
    title: "Highly Recommended",
    subName: "Loyal Customer",
    designation: "Healthcare Enthusiast",
    rating: 5,
    desc: "The pharmacy offers genuine products at competitive prices. I especially appreciate the easy prescription upload feature and secure packaging."
  },
  {
    id: 4,
    imageUrl: "https://images.pexels.com/photos/6129678/pexels-photo-6129678.jpeg?_gl=1*15t56s1*_ga*MjcyNDcwNjg5LjE3ODI3MTQ1MDI.*_ga_8JE65Q40S6*czE3ODI3MTQ1MDIkbzEkZzAkdDE3ODI3MTQ1MDIkajYwJGwwJGgw",
    name: "Meera Nair",
    title: "Great Experience",
    subName: "Verified Buyer",
    designation: "Home Maker",
    rating: 5,
    desc: "I've been ordering medicines and wellness products regularly. The discounts are excellent, delivery is always on time, and every order has been accurate."
  },
];

export { testimonials };